import heic2any from "heic2any";

const HEIC_EXTENSION = /\.(heic|heif)(?:$|[?#])/i;

export function isHeicFile(file: File): boolean {
  return (
    file.type === "image/heic" ||
    file.type === "image/heif" ||
    HEIC_EXTENSION.test(file.name)
  );
}

export function isHeicUrl(url: string): boolean {
  return HEIC_EXTENSION.test(url);
}

async function convertHeicBlobToJpeg(blob: Blob): Promise<Blob> {
  const converted = await heic2any({
    blob,
    toType: "image/jpeg",
    quality: 0.9,
  });

  return Array.isArray(converted) ? converted[0] : converted;
}

export async function convertHeicFileToJpeg(file: File): Promise<File> {
  if (!isHeicFile(file)) return file;

  const convertedBlob = await convertHeicBlobToJpeg(file);

  return new File(
    [convertedBlob],
    file.name.replace(/\.(heic|heif)$/i, ".jpg"),
    {
      type: "image/jpeg",
      lastModified: file.lastModified,
    },
  );
}

export async function convertHeicUrlToBlobUrl(url: string): Promise<string> {
  if (!isHeicUrl(url)) return url;

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Unable to download HEIC image (${response.status})`);
  }

  const convertedBlob = await convertHeicBlobToJpeg(await response.blob());
  return URL.createObjectURL(convertedBlob);
}
